/**
 * Created by zad on 17/10/18.
 */
/**
 * get entity and seq from original data
 * @param data {Array} original list
 * @return {{entities: Object, seq: Array}}
 */
export default function normalize(data) {
  const entities = {};
  const seq = [];

  data.forEach((item) => {
    const { id } = item;
    seq.push(id);
    entities[id] = item;
  });
  return {
    entities,
    seq,
  };
}

// 没啥用
// export function antiNormalize(seq, entities) {
//   const data = [];
//   seq.forEach((v) => {
//     data.push({ [v]: entities[v] });
//   });
//   return data;
// }



// WEBPACK FOOTER //
// ./src/utils/normalize.js